import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import { NitroButton } from 'nitro-components';
import OrderFuelCardForm, {
  INITIAL_ORDER_FORM,
  FORM_TYPE
} from './order-fuel-card-form';

const ContinueButton = styled(NitroButton)`
  margin-left: 8px;
`;

const Title = styled.p`
  color: ${props => props.theme.color.primary} !important;
  font-size: 20px !important;
  font-family: ${props => props.theme.font.bold};
`;

const Body = styled.div`
  padding: 32px 32px 24px;
`;

const REQUIRED_FIELDS = [
  'registration',
  'provider',
  'recipientName',
  'streetNumber',
  'address',
  'suburb',
  'postCode',
  'state',
  'country'
];

class OrderFuelCard extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      fields: { ...INITIAL_ORDER_FORM },
      errors: { ...INITIAL_ORDER_FORM },
      formType: FORM_TYPE.driverAddress
    };
  }

  componentDidUpdate = prevProps => {
    if (!prevProps.open && this.props.open) {
      this.setState({
        fields: { ...INITIAL_ORDER_FORM },
        errors: { ...INITIAL_ORDER_FORM }
      });
    }
  };

  updateField = (field, value) => {
    this.setState({
      fields: { ...this.state.fields, [field]: value },
      errors: { ...this.state.errors, [field]: false }
    });
  };

  updateFormType = formType => {
    this.setState({
      formType,
      fields: {
        ...this.state.fields,
        recipientName: '',
        address2: '',
        streetNumber: '',
        address: '',
        suburb: '',
        postCode: '',
        state: '',
        country: ''
      },
      errors: {
        ...this.state.errors,
        recipientName: false
      }
    });
  };

  validateFormFields = () => {
    const errors = { ...this.state.errors };
    REQUIRED_FIELDS.forEach(key => {
      errors[key] = !this.state.fields[key];
    });
    if (this.state.formType === FORM_TYPE.businessAddress) {
      errors.recipientName = false;
    }
    this.setState({ errors });
    return errors;
  };

  orderFuelCard = () => {
    let valid = true;
    const errors = this.validateFormFields();
    REQUIRED_FIELDS.forEach(key => {
      if (errors[key]) {
        valid = false;
      }
    });
    if (valid) {
      this.props.onOrder(this.state.fields);
    }
  };

  render() {
    const { open, onClose, ordering } = this.props;
    const { fields, errors, formType } = this.state;

    const actions = [
      <NitroButton
        size="extraSmall"
        action={onClose}
        disabled={ordering}
        label="CANCEL"
        variant="lightGreyBlue"
      />,
      <ContinueButton
        size="extraSmall"
        loading={ordering}
        disabled={ordering}
        action={this.orderFuelCard}
        label="ORDER NOW"
        variant="positive"
      />
    ];

    return (
      <Dialog
        actionsContainerStyle={{ padding: '0 32px 32px' }}
        titleStyle={{ padding: '32px 32px 0' }}
        bodyStyle={{ padding: '0', overflowY: 'initial' }}
        open={open}
        title={<Title>Order Fuel Card</Title>}
        onRequestClose={onClose}
        actions={actions}>
        <Body>
          <OrderFuelCardForm
            fields={{ ...fields }}
            disabled={ordering}
            errors={errors}
            onUpdate={this.updateField}
            onUpdateFormType={this.updateFormType}
            formType={formType}
          />
        </Body>
      </Dialog>
    );
  }
}

OrderFuelCard.defaultProps = {
  ordering: false
};

OrderFuelCard.propTypes = {
  /**
   * Boolean state indicating if the dialog is showing
   */
  open: PropTypes.bool.isRequired,

  /**
   * Action invoked when closing the dialog without saving any data
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Action invoked when an order for a fuel card should be placed
   */
  onOrder: PropTypes.func.isRequired,

  /**
   * True if the dialog should be in a loading state when a fuel card is being ordered
   */
  ordering: PropTypes.bool
};

export default OrderFuelCard;



// WEBPACK FOOTER //
// ./src/features/fuel-cards/order-fuel-card/index.js